import React, { useEffect, useState } from "react";
import styles from "./vendor.module.css";
import { Button, Dropdown } from "react-bootstrap";
import { CiCirclePlus } from "react-icons/ci";
import TMSDataTablePagination from "../../../components/TMSTable";
import { useNavigate } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import Swal from "sweetalert2";
import { post } from "../../../components/api";

const Vendor = () => {
  const [searchFirm, setSearchFirm] = useState("");
  const [queryObj, setQueryObj] = useState({});
  const navigate = useNavigate();
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
      <BsThreeDotsVertical size={"20px"} color="#2A7C7A" />
    </a>
  ));
  CustomToggle.displayName = "CustomToggle";

  const handleClick = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this vendor!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await post("https://your-api-url.com/delete", {});

        if (response.status === 200) {
          Swal.fire(
            "Deleted!",
            "Your vendor has been deleted successfully.",
            "success"
          );
        } else {
          Swal.fire(
            "Error!",
            "Something went wrong. Please try again.",
            "error"
          );
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to connect to the server.", "error");
      }
    }
  };
  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      grow: 1,
    },
    {
      name: "Website",
      selector: (row) => row.website,
      wrap: true,
      grow: 1,
      // cell: (row) => <div className={styles.address_cell}>{row.address}</div>,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      grow: 1,
    },
    {
      name: "Address",
      selector: (row) =>
        row?.address?.addressLine1.concat(",", row?.address?.addressLine2),
      grow: 2,
    },
    {
      name: "Contact Person Name",
      selector: (row) => row.contactPerson.name,
      grow: 1,
    },
    {
      name: "Actions",
      cell: (row) => (
        <Dropdown>
          <Dropdown.Toggle
            as={CustomToggle}
            style={{ display: "block", marginBottom: "50px" }}
          />
          <Dropdown.Menu
            size="sm"
            title="Actions"
            className="action-dropdown"
            style={{
              position: "absolute",
              top: "80px",
              zIndex: 1000,
            }}
          >
            <Dropdown.Item>
              <div
                className="d-flex align-items-center"
                onClick={() =>
                  navigate("/tms/update/vendors", { state: { data: row } })
                }
              >
                <span className="invoice-btn-text">Update</span>
              </div>
            </Dropdown.Item>
            <Dropdown.Item>
              <div
                className="d-flex align-items-center"
                onClick={() => handleClick()}
              >
                <span className="invoice-btn-text">Delete</span>
              </div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ),
      allowoverflow: true,
      button: true,
      grow: 0.5,
    },
  ];

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setQueryObj({ search: searchFirm });
    }, 2000);

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [searchFirm]);

  return (
    <div className={styles.MainDiv}>
      <div className={styles.HeadDiv}>
        <p className={styles.Heading}>Vendor</p>
        <div className={styles.HeaderSearchbar}>
          <input
            className={styles.Input}
            // className="form-control"
            id="username"
            name="username"
            placeholder="Search Vendor"
            onChange={(e) => setSearchFirm(e.target.value)}
            value={searchFirm}
          />
          <Button
            className={styles.addButton}
            variant="outline-secondary"
            onClick={() => navigate("/tms/add/vendors")}
          >
            <CiCirclePlus size={16} /> Add
          </Button>
        </div>
      </div>
      <div className={styles.ContentDiv}>
        <div className={styles.data_table_wrapper}>
          <TMSDataTablePagination
            columns={columns}
            apiUrl={"/admin/tms/get/vendor"}
            queryObj={queryObj}
            // data1={data}
          />
        </div>
      </div>
    </div>
  );
};

export default Vendor;
